/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { useUserChallenges } from "../../../../service/api";
import { UserChallengesList } from "./UserChallengesList";
import { css } from "@emotion/react";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { useHandleFetchError } from "../../../../error-handler";

type Props = {
  userId: string;
};

// Temp solution. Until all places have CardContainer component we have to override margin-top if other than 32px is desired.
const containerMarginTop = css`
  margin-top: 24px !important;
`;

export const UserChallenges = ({ userId }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const {
    data: challenges,
    isLoading,
    error: listUserChallengesError,
  } = useUserChallenges(organizationKeyName, userId);

  useHandleFetchError(listUserChallengesError);

  return (
    <CardContainer css={containerMarginTop}>
      <PageHeader title="Challenges" />
      <CardBody css={cardBottomPadding}>
        <UserChallengesList challenges={challenges} isLoading={isLoading} />
      </CardBody>
    </CardContainer>
  );
};
